import * as React from "react";
import { createContext, useContext } from "react";
import AuthenticationService from "../services/AuthenticationService";
import UserService from "../services/UserService";
import { ApiKeysService } from "../services/ApiKeysService";
import ProfileService from "../services/ProfileService";
import BackupsService from "../services/BackupsService";
import BillingService from "../services/BillingService";
import BluesnapService from "../services/BluesnapService";
import { ConfigurationService } from "../services/ConfigurationService";
import { DomainService } from "../services/DomainService";
import PaymentInfoService from "../services/PaymentInfoService";
import ProductsService from "../services/ProductsService";
import SupportService from "../services/SupportService";
import GtmService from "../services/GtmService";
import MetricsService from "../services/MetricsService";
import AzureMarketplaceService from "../services/AzureMarketplaceService";
import ClusterHealthService from "../services/ClusterHealthService";
import ProductAuditLogsService from "../services/ProductAuditLogsService";
import AwsMarketplaceService from "../services/AwsMarketplaceService";
import PricingService from "../services/PricingService";

export interface ServicesContextDto {
    apiKeysService: ApiKeysService;
    authenticationService: AuthenticationService;
    backupsService: BackupsService;
    billingService: BillingService;
    bluesnapService: BluesnapService;
    configurationService: ConfigurationService;
    domainService: DomainService;
    paymentInfoService: PaymentInfoService;
    productsService: ProductsService;
    metricsService: MetricsService;
    clusterHealthService: ClusterHealthService;
    profileService: ProfileService;
    supportService: SupportService;
    userService: UserService;
    gtmService: GtmService;
    azureMarketplaceService: AzureMarketplaceService;
    productAuditLogsService: ProductAuditLogsService;
    awsMarketplaceService: AwsMarketplaceService;
    pricingService: PricingService;
}

const servicesContext = createContext<ServicesContextDto>({
    apiKeysService: new ApiKeysService(),
    authenticationService: new AuthenticationService(),
    backupsService: new BackupsService(),
    billingService: new BillingService(),
    bluesnapService: new BluesnapService(),
    configurationService: new ConfigurationService(),
    domainService: new DomainService(),
    paymentInfoService: new PaymentInfoService(),
    productsService: new ProductsService(),
    metricsService: new MetricsService(),
    clusterHealthService: new ClusterHealthService(),
    profileService: new ProfileService(),
    supportService: new SupportService(),
    userService: new UserService(),
    gtmService: new GtmService(),
    azureMarketplaceService: new AzureMarketplaceService(),
    productAuditLogsService: new ProductAuditLogsService(),
    awsMarketplaceService: new AwsMarketplaceService(),
    pricingService: new PricingService(),
});

export function ServiceProvider(props: { services: ServicesContextDto; children: JSX.Element }) {
    return <servicesContext.Provider value={props.services}>{props.children}</servicesContext.Provider>;
}

export const useServices = () => {
    return useContext(servicesContext);
};
